<div class="h-100  px-4 align-middle {{styles}}">
  <co-image type="svg" key="{{expanded ? 'arrowdown' : 'arrowright'}}" [width]="'16'" [height]="'16'"></co-image>
</div>